export const HOME_ROUTING = [
  {
    path: '/',
    name: 'main',
    component: () => import(/* webpackChunkName: "home-page" */ './pages/home.page'),
    alias: ['/ab/home']
  }
];
